<template lang="pug">
  span
    | {{ label }}
</template>

<script>
export default {
  name: 'OfferVtaIndicator',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    label() {
      if (typeof this.value === 'string') {
        return this.value.toUpperCase();
      }
      return Number(this.value) ? 'VTA' : 'CTA';
    },
  },
};
</script>
